export const timeSeriesOfPatentForTrends = {
    copy: 'Copy',
    chartTitle: 'Time series of recent global patent applications',
    chartDescription:
        'Displaying the top 10 themes with the highest number of patent applications.\nIf themes are filtered, the top 10 themes within the filtered results will be displayed.',
    themeName: 'Theme Name',
    xAxis: 'Year',
    yAxis: 'Number of Patent Applications'
}
